import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Jan",
    quote:
      "What a breath of fresh air! Annelize is highly responsive and prompt in all aspects of her services. I will always recommend Virtual Bookkeeping.",
  },
  {
    name: "Carel",
    quote:
      "Annelize is a professional, through and through. If you work with this business, your books will be in order, always. Bonus — if you listen to her, you may just save yourself a boatload of money.",
  },
  {
    name: "Gideon",
    quote:
      "Virtual Bookkeeping has been assisting us with our bookkeeping and payroll, and she is exceptionally efficient. As a trade business owner, I can highly recommend her services.",
  },
];

function TestimonialCard({ testimonial, index }) {
  return (
    <div
      data-testid={`testimonial-card-${index}`}
      className="offset-hover fade-up bg-white border border-[#E1E8E9] rounded-md p-8 flex flex-col"
      style={{ animationDelay: `${0.08 * index}s` }}
    >
      <Quote size={30} className="text-[#10BFCB] mb-5" />
      <div className="flex gap-0.5 mb-4">
        {Array.from({ length: 5 }).map((_, s) => (
          <Star
            key={`star-${s}`}
            size={16}
            className="fill-[#10BFCB] text-[#10BFCB]"
          />
        ))}
      </div>
      <p className="text-[#55636B] leading-relaxed flex-1">"{testimonial.quote}"</p>
      <p className="mt-6 font-heading font-semibold text-[#10242B]">
        — {testimonial.name}
      </p>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-[#F2F7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-[#0DA2AD]">
            Client Testimonials
          </h4>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#10242B]">
            Trusted by NZ business owners
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={t.name} testimonial={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
